import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import Alert from 'components/alerts/Alert/Alert';
import Loading from 'components/Loading/Loading';
import groupBy from 'lodash/groupBy';
import moment from 'moment';
import { connect } from 'react-redux';
import { fetchBookings } from 'actions/bookingActions';
import { cancelBooking } from 'actions/reservationActions';
import { openModal } from 'actions/modalActions';

import TeacherReservation from '../TeacherReservation';

import './style.css';

class TeacherReservationList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      counter: 0,
      selectedReservationId: null
    };
  }

  componentDidMount() {
    if (this.props.user.id) {
      this.props.fetchBookings();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.user.id && prevProps.user.id !== this.props.user.id) {
      this.props.fetchBookings();
    }
  }

  handleClickDetails = (reservation) => {
    if (reservation.id === this.state.selectedReservationId) {
      this.setState({ selectedReservationId: null });
    } else {
      this.setState({ selectedReservationId: reservation.id });
    }
  }

  handleCancelReservation = (reservation) => {
    this.props.openModal('cancel-reservation-modal', {
      reservationId: reservation.id,
      firstName: reservation.student.givenName
    });
  }

  handleRescheduleReservation = (reservation) => {
    this.props.openModal('reschedule-reservation-modal', {
      reservationId: reservation.id,
      firstName: reservation.student.givenName
    });
  }

  renderReservations(groupedReservations, now) {
    const today = now.format('MM/DD/YYYY');
    const reservationList = [];
    const { source } = this.props;

    for (const dateKey in groupedReservations) {
      const dateText =
        dateKey === today ?
          `${moment(dateKey, 'MM/DD/YYYY').format('MMMM D, YYYY')} (Today)` :
          moment(dateKey, 'MM/DD/YYYY').format('MMMM D, YYYY (ddd)');
      reservationList.push(
        <p key={`title-${dateKey}`} className="teacher-reservation-list__title">
          {dateText}
        </p>
      );

      const reservations = groupedReservations[dateKey];
      for (const reservation of reservations) {
        reservationList.push(
          <TeacherReservation
            key={reservation.id}
            now={now}
            reservation={reservation}
            onDetails={this.handleClickDetails}
            onCancel={this.handleCancelReservation}
            onReschedule={this.handleRescheduleReservation}
            active={this.state.selectedReservationId === reservation.id}
            source={source}
          />
        );
      }
    }
    return reservationList;
  }

  render() {
    const reservations = this.props.reservations ? Object.values(this.props.reservations) : [];
    for (const r of reservations) {
      r.day = moment(r.startTime).format('MM/DD/YYYY');
    }
    const { reservationsStatus } = this.props;
    const groupedReservations = groupBy(reservations, 'day');
    const now = moment();

    return (
      <div className="teacher-reservation-list">
        {reservationsStatus !== 'SUCCESS' ? (
          <Loading />
        ) : (
          <Fragment>
            <p className="teacher-reservation-list__title">
              {`${_.size(
                reservations
              )} upcoming lessons`}
            </p>
            {reservations.length > 0 ? (
              this.renderReservations(groupedReservations, now)
            ) : (
              <Alert alertType="warning">
                <h4>No upcoming reservations</h4>
              </Alert>
            )}
          </Fragment>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.profile,
    reservations: state.bookings.bookings,
    reservationsStatus: state.bookings.status
  };
}

export default connect(
  mapStateToProps,
  {
    openModal,
    fetchBookings,
    cancelBooking
  }
)(TeacherReservationList);



// WEBPACK FOOTER //
// ./src/components/TeacherReservationList/index.js